import { Box, Typography, styled } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

import { useFlag } from "~/config/flags";

const AutostoreBinNumberStyled = styled(Box, {
  shouldForwardProp: (propName: string) =>
    !["enableColorChanges"].includes(propName)
})<{
  enableColorChanges: boolean;
}>(({ theme: { palette }, enableColorChanges }) => ({
  position: "absolute",
  bottom: 0,
  width: "100%",
  textAlign: "center",
  color: palette.common.white,
  background: enableColorChanges
    ? alpha(palette.autostoreDesignSystem.colour.primary.asBlack800, 0.8)
    : "rgba(0, 0, 0, 0.52)"
}));

export const AutostoreBinNumber = ({ binNumber }: { binNumber: number }) => {
  const { t } = useTranslation();
  const { enableColorChanges } = useFlag();
  return (
    <AutostoreBinNumberStyled
      zIndex={10}
      enableColorChanges={enableColorChanges}
    >
      <Typography variant="h5">
        {t("bin")} {binNumber}
      </Typography>
    </AutostoreBinNumberStyled>
  );
};
